/**
 * 库存查询（接口服务）
 */
import request from "@utils/request";

const InventoryQueryService = {
    /**
     * 列表查询
     *
     * @description http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6425
     */
    queryList(data) {
        return request({
            url: "/service/mg/stock/list",
            method: "POST",
            data
        });
    },

    /**
     * 客户详情
     *
     * @description http://rap.essa.top:88/workspace/myWorkspace.do?projectId=210#6426
     */
    queryDetail(data) {
        return request({
            url: "/service/mg/stock/query-details",
            method: "POST",
            data
        });
    },

    /**
     * PO单详情
     *
     * @description
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=84#6158
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=84#6194
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=84#6227
     */
    queryPoDetail(data) {
        return new Promise(resolve => {
            request.all([function () {
                return request({
                    url: "/mg/po/essa-one/po-header",
                    method: "POST",
                    data: {id: data.poId}
                });
            }(), function () {
                return request({
                    url: "/mg/po/essa-one/po-item-list",
                    method: "POST",
                    data: {poId: data.poId}
                });
            }(), function () {
                return request({
                    url: "/mg/po/essa-one/trackMg",
                    method: "POST",
                    data: {orderId: data.poId}
                });
            }()]).then(request.spread((res1, res2, res3) => {
                let data = {};
                if (res1.data.success && res1.data.valid) {
                    data.header = res1.data.model;
                }
                if (res2.data.success && res2.data.valid) {
                    data.list = res2.data.model;
                }
                if (res3.data.success && res3.data.valid) {
                    data.trace = res3.data.models;
                }
                if (data.header && data.list && data.trace) {
                    resolve(data);
                }
            }))
        })
    }
};

export default InventoryQueryService;
